<template>
  <div class="row">
    <div class="col-md-12">
      <div class="form-horizontal">
        <div
          :class="'form-group ' + (validations !== null && validations.hasOwnProperty('title_km') ? 'has-error' : '')"
        >
          <label class="col-sm-3 control-label required">{{ $t('fields.khmerName') }}</label>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control"
              v-model="background.title_km"
              :placeholder="$t('fields.khmerName')"
            >
            <span
              class="label-error"
              v-if="validations !== null && validations.hasOwnProperty('title_km')"
            >
              {{ validations['title_km'][0] }}
            </span>
          </div>
        </div>

        <div
          :class="'form-group ' + (validations !== null && validations.hasOwnProperty('title_en') ? 'has-error' : '')"
        >
          <label class="col-sm-3 control-label required">{{ $t('fields.englishName') }}</label>
          <div class="col-sm-9">
            <input
              type="text"
              class="form-control"
              v-model="background.title_en"
              :placeholder="$t('fields.englishName')"
            >
            <span
              class="label-error"
              v-if="validations !== null && validations.hasOwnProperty('title_en')"
            >
              {{ validations['title_en'][0] }}
            </span>
          </div>
        </div>

        <div :class="'form-group ' + (validations !== null && validations.hasOwnProperty('image') ? 'has-error' : '')">
          <label class="col-sm-3 control-label">{{ $t('fields.image') }}</label>
          <div class="col-sm-9">
            <input
              type="file"
              id="icon"
              ref="image"
              accept="image/jpeg,image/png,image/jpg"
              class="custom-file-input"
              @change="previewFiles"
            >
            <label for="icon">
              {{ $i18n.locale === "km" ? 'ជ្រើសរើសរូបតំណាង' : 'Choose an image' }}
            </label>
            <tooltip-info>
              <p>Background image size: </p>
              <ul style="margin: 15px;padding: 0;">
                <li>Dimension 1920x1080 Pixels</li>
                <li>Aspect ratio 1:1</li>
              </ul>
            </tooltip-info>
            <span
              class="label-error"
              v-if="validations !== null && validations.hasOwnProperty('image')"
            >
              <br>{{ validations['image'][0] }}
            </span>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <img
              v-if="preview"
              :src="preview"
              class="preview-img"
              alt="Image"
            >
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ $t('fields.active') }}
          </label>
          <div class="col-sm-9">
            <input
              type="checkbox"
              :value="true"
              v-model="background.active"
            >
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-3 col-sm-9">
            <button
              @click="newBackground"
              class="btn btn-primary margin-right-5 btn-sm btn-update"
            >
              {{ $t('buttons.save') }}
            </button>
            <button
              @click="$router.push({name: 'list-background'})"
              class="btn btn-default btn-sm btn-back"
            >
              {{ $t('buttons.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TooltipInfo from '@/components/TooltipInfo'

export default {
  name: 'BackgroundForm',
  components: { TooltipInfo },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      background: {
        title_km: '',
        title_en: '',
        active: true
      },
      preview: process.env.VUE_APP_API + '/img/default.png',
      uuid: null,
      validations: null
    }
  },
  methods: {
    getBackground () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/background/show', {
        background_uuid: this.$route.params.uuid
      }).then((response) => {
        if (response.data.code === 1) {
          const res = response.data.data
          this.background = {
            uuid: res.uuid,
            title_en: res.title_en,
            title_km: res.title_km,
            active: res.active
          }
          this.preview = process.env.VUE_APP_API + '/' + res.image
        }
      }).catch((error) => {
        this.onResponseError(error)
      })
    },
    newBackground () {
      const data = new FormData()
      for (const key in this.background) {
        const value = this.background[key]
        if (value === '') {
          data.delete(key)
        } else {
          data.set(key, value)
        }
      }
      if (this.$refs.image.files.length > 0) {
        data.set('image', this.$refs.image.files[0])
      } else {
        data.delete('image')
      }
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/background/store', data)
        .then((response) => {
          if (response.data.code === 1) {
            this.$toastr('success', 'The request was processed', 'Background')
            this.$router.push({
              name: 'list-background'
            })
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.validations = error.response.data.errors
          } else {
            this.validations = []
            this.onResponseError(error)
          }
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    previewFiles (e) {
      this.background.icon = e.target.files[0]
      this.preview = URL.createObjectURL(this.background.icon)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$route.params.hasOwnProperty('uuid')) {
        this.uuid = this.$route.params.uuid
        this.getBackground()
      }
      if (!this.editable) {
        $('input').attr('disabled', 'disabled')
      }
    })
  }
}
</script>

<style scoped>
.preview-img {
  width: 25%;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}

[type="file"] {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  white-space: nowrap;
  width: 1px;
}

[type="file"] + label {
  background-color: #3b569f;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  padding: 5px 10px;
}

[type="file"]:focus + label,
[type="file"] + label:hover {
  background-color: #2c4077;
}

[type="file"]:focus + label {
  outline: 1px dotted #000;
}

@media screen and (max-width: 992px) {
  .preview-img {
    width: 45%;
  }
}

@media screen and (max-width: 768px) {
  .preview-img {
    width: 35%;
  }
}

@media screen and (max-width: 576px) {
  .preview-img {
    width: 40%;
  }
}
</style>
